<template>
  <b-sidebar
    id="sidebar-edit-group"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Edit Group</h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- Body -->
      <validation-observer ref="groupEditFormValidator" #default="{ invalid }">
        <b-form class="p-2" @submit.prevent="editGroup" ref="groupEditForm">

           <b-form-group label-for="name" label="Group Name">
              <validation-provider
                #default="{ errors }"
                name="Group Name"
                vid="name"
                rules="required"
              >
                <b-form-input
                  id="name"
                  v-model="name"
                  name="name"
                  placeholder="Group Name"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label-for="description" label="Group Description">
              <validation-provider
                name="Group Description"
                vid="description"
              >
                <b-form-textarea
                  id="description"
                  v-model="description"
                  name="description"
                  placeholder="Group Description"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </validation-provider>
            </b-form-group>

          <!-- Form Actions -->
          <div class="d-flex align-items-center justify-content-between">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              :disabled="invalid || formIsLoading"
              :class="{ disabled: invalid }"
            >
              <b-spinner small v-if="formIsLoading" />
              &nbsp;
              Submit
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="hide"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";

import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BButton,
  BSpinner,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BSpinner,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props:["id"],
  emits: ["groups-refresh","reset-id"],
  data() {
    return {
      name: "",
      description:"",
      formIsLoading:false,
      required,
    };
  },
  methods: {
    editGroup() {
      this.formIsLoading = true;
      this.$refs.groupEditFormValidator.validate().then((success) => {
        if (success) {
          this.$http.put('/contact-group/update',{
            id:this.id,
            name: this.name,
            description: this.description,
          })
          .then(response => {
            this.formIsLoading = false;
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: response.data.message,
                icon: "CheckIcon",
                variant: "success",
              },
            });
            this.$emit('groups-refresh')
            this.$root.$emit('bv::toggle::collapse', 'sidebar-edit-group')
            this.$nextTick(() => {
              this.$refs.groupEditFormValidator.reset();
            });
          })
          .catch(error => {
              for (let err of error.response.data.error) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title:err,
                    icon: "AlertCircleIcon",
                    variant: "danger",
                  },
                });
              }
              this.formIsLoading = false;
          })
        }
      });
    },
  },
  mounted(){
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if(collapseId == "sidebar-edit-group" && isJustShown){
        if(this.id && this.id != null && this.id != undefined){
          this.formIsLoading = true;
          this.$http
            .get("/contact-group/show/"+ this.id)
            .then((response) => {
              this.name = response.data.data.name;
              this.description = response.data.data.description;
              this.formIsLoading = false;
            })
            .catch((error) => {
              for (let err of error.response.data.error) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: err,
                    icon: "AlertCircleIcon",
                    variant: "danger",
                  },
                });
              }
              this.formIsLoading = false;
            });
        }
      }
      if(collapseId == "sidebar-edit-contact" && !isJustShown){
        this.$emit('reset-id')
      }
    })
  }
};
</script>